import { defineStore } from 'pinia'
import moment from 'moment'
import repositoryFactory from '@/factories/repository-factory'
import WeatherWarningHistoryRepository from '@/repositories/weather-warning-history-repository'
import WeatherWarningHistory, { WeatherWarningHistoryItem } from '@/models/WeatherWarningHistory'
import { AlertKind } from '@/models/WeatherWarning'
import { rangeToISO } from '@/lib/formatter'
import { WEATHER_WARNINGS } from '@/lib/constants'

const storeKey = 'weather-warning-history'

type Store = {
  weatherWarningHistory: WeatherWarningHistory
}

export const useWeatherWarningHistoryStore = defineStore(storeKey, {
  state: () =>
    ({
      weatherWarningHistory: {} as WeatherWarningHistory,
    } as Store),

  actions: {
    async fetch(areaCode: string) {
      const repoKey = 'weatherWarningHistory'
      const repository = (await repositoryFactory.create()).get(repoKey) as WeatherWarningHistoryRepository
      const startTime = moment().add(-1, 'month').format()
      const endTime = moment().format()
      const range = { startTime, endTime }
      const params = {
        areaCode,
        range: rangeToISO(range as Range),
      }
      this.weatherWarningHistory = await repository.get(params)

      this.weatherWarningHistory.weatherWarningData.forEach((item: WeatherWarningHistoryItem) => {
        const additionalKinds: AlertKind[] = []

        item.kinds.forEach((kind: AlertKind) => {
          if (kind.name.includes('警報') && kind.status === '発表') {
            const name: string = kind.name.substring(0, kind.name.indexOf('警報'))
            const warnings = WEATHER_WARNINGS.find(w => w.name === name && w.type === 'warn')
            if (warnings) {
              additionalKinds.push({
                name: `${name}注意報`,
                code: warnings.code,
                status: '切り替わり',
              })
            }
          } else if (kind.name.includes('注意報') && kind.status === '警報から注意報') {
            const name: string = kind.name.substring(0, kind.name.indexOf('注意報'))
            const warnings = WEATHER_WARNINGS.find(w => w.name === name && w.type === 'specia')
            if (warnings) {
              additionalKinds.push({
                name: `${name}警報`,
                code: warnings.code,
                status: '切り替わり',
              })
            }
          }
        })

        item.kinds.push(...additionalKinds)
      })
    },
  },
})
